<template>
  <v-container class="container--max ch-single">
    <slot name="ad-leaderboard" class="d-print-none">
      <ad-leaderboard></ad-leaderboard>
    </slot>
    <v-row justify="center" class="my-4">
      <!-- left -->
      <v-col cols="11" sm="9" md="8" lg="7">
        <slot name="main"></slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'AppSingleLongread'
  }
</script>